import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "./Skills.scss";
import Skill from "../../assets/images/gifs_tech.jpg";

function Skills() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const techStackCategories = [
        {
            title: "Languages",
            skills: ["Java", "Python", "JavaScript", "TypeScript", "SQL", "HTML5", "CSS3", "C++"],
            color: "#64ffda"
        },
        {
            title: "Java",
            skills: ["Core Java", "Multithreading", "Collections Framework", "OOP", "Memory Management"],
            color: "#00d4ff"
        },
        {
            title: "Frontend",
            skills: ["React.js", "Tailwind CSS", "Bootstrap"],
            color: "#ff6b6b"
        },
        {
            title: "Backend",
            skills: ["Node.js", "Express.js", "Django", "RESTful APIs", "Database Operations"],
            color: "#22c55e"
        },
        {
            title: "Databases",
            skills: ["MongoDB", "MySQL"],
            color: "#a855f7"
        },
        {
            title: "Tools & Others",
            skills: ["Git/GitHub", "Maven", "Linux", "Veracode", "AWS", "Agile/Scrum", "CI/CD"],
            color: "#f59e0b"
        }
    ];

    return (
        <Container fluid className="skills-section" id="skills">
            <Container>
                <Row className="align-items-center">
                    {/* Left Column - Tech Stack */}
                    <Col lg={6} md={12} className="tech-stack-column">
                        <div className={`tech-stack-content ${isVisible ? 'slide-in' : ''}`}>
                            <div className="section-header">
                                <h2 className="section-title">
                                    Skills
                                    <span className="title-underline"></span>
                                </h2>
                            </div>

                            <div className="tech-stack-grid">
                                {techStackCategories.map((category, categoryIndex) => (
                                    <Card key={categoryIndex} className="tech-category-card">
                                        <Card.Body>
                                            <Card.Title className="category-title">
                                                {category.title}
                                            </Card.Title>
                                            <div className="skills-badges">
                                                {category.skills.map((skill, skillIndex) => (
                                                    <Badge 
                                                        key={skillIndex} 
                                                        className="skill-badge"
                                                        style={{ '--badge-color': category.color }}
                                                    >
                                                        {skill}
                                                    </Badge>
                                                ))}
                                            </div>
                                        </Card.Body>
                                    </Card>
                                ))}
                            </div>
                        </div>
                    </Col>
                    {/* Right Column - Developer Animation */}
                    <Col lg={6} md={12} className="animation-column">
                        <div className={`animation-wrapper ${isVisible ? 'fade-in' : ''}`}>
                            <div className="animation-container">
                                <img 
                                    alt="Developer Animation" 
                                    src={Skill} 
                                    className="developer-animation" 
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default Skills;
